import { getCurrencySymbol } from "../../../constants";
export function chargeRow(charge, t) {
    if (charge.kind === "ACTIVE_PACK") {
        return {
            label: t("consultationFee"),
            value: t("free", "Free"),
            caption: t("coveredBySessionPack", "Covered by session pack"),
        };
    }
    const price = `${getCurrencySymbol(charge.currency)}${charge.amount.toLocaleString()}`;
    switch (charge.kind) {
        case "PACK_PURCHASE":
            return {
                label: t("packagePrice", "Package Price"),
                value: price,
                caption: charge.packName,
            };
        case "FOLLOW_UP":
            return {
                label: t("followUpFee", "Follow-up Fee"),
                value: charge.amount === 0 ? t("free", "Free") : price,
                caption: t("followUpVisit", "Follow-up visit"),
            };
        case "CONSULTATION":
            return { label: t("consultationFee"), value: price, caption: null };
    }
}
export function unquotedChargeRow(selectedPack, t) {
    const value = t("priceUnavailable", "Price unavailable");
    return selectedPack
        ? {
            label: t("packagePrice", "Package Price"),
            value,
            caption: selectedPack.packageName || null,
        }
        : { label: t("consultationFee"), value, caption: null };
}
